export const VARIABLE = 'VARIABLE';
export const DOT = '.';
export const DASH = '-';
